import { Component, ChangeDetectionStrategy, Input } from '@angular/core';

import { GasBageType } from './gas-badge.interface';

@Component({
  selector: 'gas-badge',
  templateUrl: './gas-badge.component.html',
  styleUrls: ['./gas-badge.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GasBadgeComponent {
  /** тема для лейбла */
  @Input()
  public theme: GasBageType = 'default';

  /** имя иконки слева от текста */
  @Input()
  public suffixIcon: string;

  /** имя иконки справа от текста */
  @Input()
  public postfixIcon: string;
}
